/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../clients/axios.ts";
import type { RequestConfig, ResponseErrorConfig } from "../../../clients/axios.ts";
import type { PatchApiAlbumsIdNameMutationRequest, PatchApiAlbumsIdNameMutationResponse, PatchApiAlbumsIdNamePathParams, PatchApiAlbumsIdName400, PatchApiAlbumsIdName401, PatchApiAlbumsIdName403, PatchApiAlbumsIdName404, PatchApiAlbumsIdName500 } from "../../types/PatchApiAlbumsIdName.ts";
import { patchApiAlbumsIdNameMutationResponseSchema, patchApiAlbumsIdNameMutationRequestSchema } from "../../zod/AlbumSchemas/patchApiAlbumsIdNameSchema.ts";

function getPatchApiAlbumsIdNameUrl({ id }: { id: PatchApiAlbumsIdNamePathParams["Id"] }) {
  const res = { method: 'PATCH', url: `/api/albums/${id}/name` as const }  
  return res
}

/**
 * @summary Обновление названия альбома
 * {@link /api/albums/:Id/name}
 */
export async function patchApiAlbumsIdName({ id, data }: { id: PatchApiAlbumsIdNamePathParams["Id"]; data?: PatchApiAlbumsIdNameMutationRequest }, config: Partial<RequestConfig<PatchApiAlbumsIdNameMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = patchApiAlbumsIdNameMutationRequestSchema.parse(data)  
  
  const res = await request<PatchApiAlbumsIdNameMutationResponse, ResponseErrorConfig<PatchApiAlbumsIdName400 | PatchApiAlbumsIdName401 | PatchApiAlbumsIdName403 | PatchApiAlbumsIdName404 | PatchApiAlbumsIdName500>, PatchApiAlbumsIdNameMutationRequest>({ method : "PATCH", url : getPatchApiAlbumsIdNameUrl({ id }).url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/*+json', ...requestConfig.headers } })  
  return patchApiAlbumsIdNameMutationResponseSchema.parse(res.data)
}